import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const ipAddressSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        fill="#e3e3e3"
        d="M20.609 10.087c0 6.696-8.61 12.913-8.61 12.913s-8.608-6.217-8.608-12.913C3.391 5.069 6.981 1 12 1s8.609 4.069 8.609 9.087"
      ></path>
      <path
        fill="#fff"
        d="M12 23s-8.61-6.217-8.61-12.913C3.391 5.069 6.981 1 12 1z"
      ></path>
      <path
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.609 10.087c0 6.696-8.61 12.913-8.61 12.913s-8.608-6.217-8.608-12.913C3.391 5.069 6.981 1 12 1s8.609 4.069 8.609 9.087"
        strokeWidth={1}
      ></path>
      <path
        fill="#66e1ff"
        d="M12 15.348c4.418 0 7.179-4.783 4.97-8.61A5.74 5.74 0 0 0 12 3.87c-4.418 0-7.18 4.782-4.97 8.608a5.74 5.74 0 0 0 4.97 2.87"
      ></path>
      <path
        fill="#78eb7b"
        d="M11.043 10.564a.957.957 0 0 0-.956-.956a.957.957 0 0 1-.957-.957c0-.792-.642-1.434-1.434-1.435H6.78a5.75 5.75 0 0 0 .557 5.74h1.314a2.39 2.39 0 0 0 2.391-2.392m4.753-5.261a2.366 2.366 0 0 0-2.36 2.392c0 .528.428.956.956.956c.529 0 .957.428.957.957c0 .792.642 1.435 1.435 1.434h.775a5.75 5.75 0 0 0-1.763-5.739"
      ></path>
      <path
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 15.348c4.418 0 7.179-4.783 4.97-8.61A5.74 5.74 0 0 0 12 3.87c-4.418 0-7.18 4.782-4.97 8.608a5.74 5.74 0 0 0 4.97 2.87"
        strokeWidth={1}
      ></path>
      <path
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.781 7.217h.915c.792 0 1.434.643 1.434 1.435c0 .528.429.957.957.957s.957.428.957.956a2.393 2.393 0 0 1-2.392 2.392H7.338m10.22-1.913h-.775a1.435 1.435 0 0 1-1.435-1.435a.957.957 0 0 0-.957-.957a.957.957 0 0 1-.956-.956a2.364 2.364 0 0 1 2.361-2.392"
        strokeWidth={1}
      ></path>
    </g>
  </svg>
);
const IpAddressIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ipAddressSvg} {...props} />
);
export default IpAddressIcon;
